<p-toast position="top-center" key="message">
  <ng-template let-message pTemplate="message" let-closeFn="closeFn">
    <div class="toast-container" [style.width]="message.data?.width || null">
      <div *ngIf="message.data?.icon">
        <app-svg-loader [name]="message.data.icon" [url]="message.data.icon + '.svg'">
        </app-svg-loader>
      </div>
      <div class="toast-icon" *ngIf="message.severity === 'success'">
        <app-svg-loader name="check-circle" url="check-circle.svg"> </app-svg-loader>
      </div>
      <section>
        <span *ngIf="message.data?.title" class="toast-title">
          {{ message.data.title }}
        </span>
        <br *ngIf="message.data?.title" />
        <span class="toast-message" [innerHTML]="message.data.body"></span>
      </section>
    </div>
  </ng-template>
</p-toast>
<app-notification></app-notification>
<router-outlet></router-outlet>
